import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const defaultTypeStyle = {
  leftBox: {
    maxWidth: '92%',
    flexDirection: 'row',
    alignSelf: 'center',
  } as BoxProps,
  titleText: {
    fontSize: 12,
    color: Colors.BLACK_14 as ColorOptions,
    fontWeight: '600',
    fontFamily: 'JioType-Medium',
    lineHeight: 20,
    textAlign: 'left',
    letterSpacing: -0.08,
    numberOfLines: 2,
  } as TextProps,
}

const defaultPositionStyle = {
  position: 'absolute',
  // right: 16,
  align: 'center',
  paddingHorizontal: 16,
  paddingVertical: 14,
  alignSelf: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  borderRadius: 32,
} as BoxProps

export const styles = {
  TOP: { containerView: { ...defaultPositionStyle, top: 72 } as BoxProps },
  BOTTOM: { containerView: { ...defaultPositionStyle, bottom: 24 } as BoxProps },
  CENTER: {
    containerView: { ...defaultPositionStyle, top: 0, bottom: 0 } as BoxProps,
  },
  TOP_POSITIVE_ACTION_VIEW: {
    containerView: {
      ...defaultPositionStyle,
      flexDirection: 'column',
      top: 72,
      align: 'flex-start',
    } as BoxProps,
  },
  NEGATIVE: {
    actionContainer: {
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    leftBox: {
      ...defaultTypeStyle.leftBox,
    },
    bgColor: {
      backgroundColor: 'ERROR',
    } as BoxProps,
    actionText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
  },
  POSITIVE: {
    actionContainer: {
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    leftBox: {
      ...defaultTypeStyle.leftBox,
    },
    bgColor: {
      backgroundColor: 'GREEN',
    } as BoxProps,
    actionText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
  },
  NEUTRAL: {
    actionContainer: {
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    leftBox: {
      ...defaultTypeStyle.leftBox,
    },
    bgColor: {
      backgroundColor: 'PRIMARY',
    } as BoxProps,
    actionText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
  },
  ACTION_VIEW: {
    actionContainer: {
      underlayColor: 'TRANSPARENT',
    } as BoxProps,
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    leftBox: {
      ...defaultTypeStyle.leftBox,
      paddingRight: 8,
    },
    bgColor: {
      backgroundColor: 'BLACK_21',
    } as BoxProps,
    actionText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
  },
  POSITIVE_ACTION_VIEW: {
    actionContainer: {
      underlayColor: 'TRANSPARENT',
      borderWidth: 1,
      borderRadius: 4,
      borderColor: 'WHITE',
      padding: 6,
      justifyContent: 'flex-start',
      marginLeft: 48,
      marginTop: 16,
    } as BoxProps,
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    leftBox: {
      ...defaultTypeStyle.leftBox,
      paddingRight: 8,
    },
    bgColor: {
      backgroundColor: 'GREEN',
    } as BoxProps,
    actionText: {
      ...defaultTypeStyle.titleText,
      fontSize: 12,
      fontWeight: '500',
      color: 'WHITE',
    } as TextProps,
  },
}
